// type predicate to assert whether object has a property defined on it
export const hasProperty = <X, Y extends PropertyKey>(
  obj: X,
  prop: Y,
): obj is X & Record<Y, unknown> => typeof obj === 'object' && obj !== null && prop in obj;
